<template>
  <div>

    <!-- SIDE -->
    <div id="side-left">
      <div class="header">
        <h1 class="logo">
          <svg width="67" height="40" xmlns="http://www.w3.org/2000/svg"><path d="M46.8777912 18.405255c3.3986754 1.4671566 2.9237603 6.8224839 1.2214672 10.9661476-1.5110934 3.6789441-5.2186691 6.3919501-8.4305136 6.6844561-3.316953.3030444-5.8413528-2.501209-4.9935471-5.0479133.2423403-.6968223.9922333-1.484635 1.5863911-1.8460265 3.6962682-2.2482864 5.17678 3.392864.9832387 3.5146987.5319666 3.1330014 5.2659551 1.7324169 7.0286404-3.2052283 1.5892181-4.452877 1.8482626-10.0845171-3.0550814-8.6749363l.3328003-2.0953506c3.0023988-1.4643292 3.8532883-3.0312155 4.2626713-4.8024447 1.0518547-4.5515785-4.5664319-6.1015004-4.6378747-3.3106128 3.1794639.2943053 2.4262301 2.654145 1.5861341 3.232217-1.7554897 1.2083223-5.3047603-1.1399508-3.6412726-4.0943129 3.6631167-6.4366742 14.8339007-.3115266 7.7569463 8.679306zm-23.161269 8.148953l1.264733-7.6550671-1.8263416.3146726.1713915-1.0867243 1.8349898-.3110794c.2405771-1.5168968.5872911-3.1328667 1.0587488-3.9665183 1.4788414-2.6238977 3.8167369-2.3908449 4.7486455-1.3634104.7162278.7905317.500547 2.2399253-.8134545 2.5846279-1.3698218.3731925-1.8166452-1.7961496.0649925-1.7070864.0602753-.9096248-1.3454496-1.0074146-1.855431-.0097533-.4397477 1.0515611-.6716766 2.9318971-.8870952 4.0622547l1.8231968-.313646-.169295 1.0849277-1.8247692.3087694-1.2765261 7.6807337c-.2101773 1.3711105-.618477 3.2732631-1.0514109 4.5368304-.5424777 1.5818334-1.9193752 3.2950797-3.8473987 2.9721937-.6203114-.1062597-1.2424574-.5176955-1.5236548-1.4383569 1.500593 1.3567371 2.5147904.4319691 3.2027151-1.6257232.1352263-.4057892.6040633-2.0972189.905964-4.0676448zm10.008968-10.8679335c-.5697824 1.1023335-1.3262177 1.9306028-2.3529412 2.3529412.5034052-.6614609.9213164-1.3435829 1.0328302-2.0977151.439683-.0850754.880428-.1707584 1.320111-.2552261zm-19.4408667 9.5732837c.382679-1.9129038 1.786511-4.5194952 3.5436436-5.1966966.2018499-.0778655.4085118-.130114.6187194-.1524337.5566702-.060872 1.0072235.1110915 1.3590046.5790452l.0780047-.5222313 2.0739636-.3593987-1.0905468 6.8298427c-.2563012 1.781268.5645213 1.5811511 1.8776854.0646765l-.2411055 1.4954231c-1.258966 1.3774834-3.2787315 1.7805071-3.7969058-.211784-.2796014.4798745-.5723724.8727528-.8788196 1.1809175-.4589109.4611057-.9479601.7309717-1.4696801.8080763-2.4665198.3659931-2.4092826-2.8308034-2.0739635-4.515437zm4.5506138-4.1621256c-.3454495.0081163-.6893795.2871131-1.0069702.7307181-1.3501404 1.8847505-2.2368111 6.7486799-.8476683 6.5434904.282134-.0218125.5716126-.3413907.8476683-.8342005.4571382-.8146708.8795794-2.1082016 1.1774157-3.3302078.3976215-1.622747.6465782-3.1290763-.1704455-3.1098002zm12.6525438 5.6572307c1.2584229-.3111117 2.1411534-1.2491804 3.0220228-2.1688402l-.2690733 1.6231456c-.6886362.9380687-1.6979269 1.5560843-2.7529495 1.8432643-.5086336.1375414-1.0265731.1988169-1.5248373.179619-1.371423-.0491782-2.3631655-.9932956-2.4647326-2.3048036-.3658546-2.6955998 1.4344371-6.7739766 3.9895699-7.6960033.235838-.0846813.4796524-.144116.7266574-.1719924 1.0122155-.1128207 1.9752426.2466803 2.16721 1.3078261.2637556 1.7664726-1.3161194 3.2084213-2.8938674 4.2600997-.5966408.395267-1.1924839.736622-1.688621 1.0169644-.1733556 1.2773198-.1544779 2.4678545 1.5025031 2.1504312.0622166-.0115714.1249649-.0255096.1861179-.0397108zm0-6.8105316c-.6939538.9051956-1.2451287 2.6261717-1.4950584 3.5024389.43977-.2422095.9888178-.5762009 1.4950584-.9785685.8739565-.6945443 1.6232139-1.5931653 1.4759149-2.5777824-.052113-.3463517-.3592075-.5756749-.6984739-.5257077-.2725297.0449705-.5338924.2621964-.777441.5796197zm25.3123578-5.4337186c2.4583181-2.2420662 5.9550281-3.0351272 7.9191561-.9492505 3.123167 3.8485495 1.264477 12.7956797-3.326566 17.080838-8.4360322 7.873392-14.8184818-1.5036457-8.8771168-4.1462373 3.3193482-1.3899831 4.416517 3.6508641.4261326 3.8387554.9074328 3.2737929 5.6714553 1.9008206 8.0142822-5.8413827 3.926967-12.9727459-6.910153-7.4246695-7.9266325-5.5983353l2.1969156-13.5866788C59.318781 5.1434271 63.633469 4.7452213 66.666667 0c-.923932 4.8052744-1.846317 7.6507061-8.8379323 8.1976269l-1.0285958 6.3127862zm-44.1756308 1.7967237c-1.7716789 2.3537865-3.5707681 5.7201311-3.9306884 8.6958634 1.3597559-.6709935 2.7269407-1.8511735 3.9306884-3.2131336 2.7979-3.1678781 4.7148278-7.324296 3.6148294-8.3765473-.5044008-.4770779-2.0483436.8115633-3.6148294 2.8938175zm0 21.5567407c4.509891 2.3140932 11.6188933-.7817302 15.9159062-7.8939074.8901943-.1069443 2.8793624-.4343507 4.4007622-.8001863-.029972.0498063-.0043549.0030339-.0345831.0520817-3.8090071 6.3334808-13.3139771 12.1721862-20.2820853 10.4830725-3.8914942-.945307-6.9921884-4.2370686-7.8665001-11.1042598-8.8873416-2.7547646-4.1545818-13.9973188 4.608773-14.3553169-7.3541579 2.9997505-9.6433023 9.3969429-4.1225604 11.31739 1.2396117-6.380506 4.5193694-10.2428902 7.3802875-12.198227 2.1751482-1.4863492 4.1082148-1.871905 4.7220006-1.4244074 1.5928715 1.1832138-.2343965 7.8165433-4.7220006 12.6270156-1.202723 1.2893997-2.5939879 2.4478369-4.163804 3.3349944-.2405446 5.3770497 1.5132023 8.6023188 4.163804 9.9617506z" fill="#F2C616" fill-rule="evenodd"/></svg>
        </h1>
        <a href="/" title="acesse o site">Acesse o site</a>
      </div>
      <div class="content groupe-titles">
        <h1 class="title f-color-primary">Encontre um ponto de venda próximo a você</h1>
        <div class="clearfix"></div>
        
        <span class="veja-lista" v-if="listActive" @click="closeList()">Ver no mapa</span>
        <span class="veja-mapa" v-if="!listActive" @click="openList()">Ver em lista</span>
        <div class="select">
          <i>
            <svg width="14" height="8" xmlns="http://www.w3.org/2000/svg"><path d="M1 1l5.7855469 5.644436L12.5710938 1" stroke="#1C1C1C" stroke-width="1.5" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round"/></svg>
          </i>
          <select @change="onChange($event)" v-model="cidade">
            <option v-for="(city, index) in cidades" :selected="city.id === cidade" :value="city.id"> {{city.nome}}  </option>
          </select>
        </div>
        <div class="clearfix"></div>
        <h3 class="exibindo" v-if="cidades">
          Exibindo 
          <span v-if="cidades">{{ cidades[cidade].total }}</span> 
          <span v-if="cidades && cidades[cidade].total === 1"> local</span> <span v-if="cidades && cidades[cidade].total > 1"> locais</span></h3>
        <div class="clearfix"></div>
        <!-- Listagem -->
        <div class="listagem" id="listagem" :class="{ active: listActive }" >
          <ul ref="listagem" > 
            <li ref="loja" v-for="(loja, index) in dealers" :id="index" v-if="loja.cidade ==  cidade" @click="openMarker({lat: parseFloat(loja.geolocation.latitude), lng: parseFloat(loja.geolocation.longitude)}, index)" :class="{'active':(index === currentMarker)}">
              <h2 class="name">{{ loja.nome }}</h2>
              <h3>{{ loja.tipo }}</h3>
              <address>{{ loja.geolocation.endereco }}</address>
              <address>{{ loja.bairro }}</address>
            </li>
          </ul>
        </div>
      </div>

      <!-- Box do mobile -->
      <transition name="fade">
        <div class="activeMarker" v-if="currentDealer" :class="{'active':(currentDealer != null)}">
          <h2 class="name">{{ currentDealer.nome }}</h2>
          <h3>{{ currentDealer.tipo }}</h3>
          <address>{{ currentDealer.geolocation.endereco }}</address>
          <address>{{ currentDealer.bairro }}</address>
        </div>
      </transition>
    </div>

    <div class="isMobile location" v-if="latitude && longitude"  @click="openMarker({lat: parseFloat(latitude), lng: parseFloat(longitude)})">
      <img src="/cafe35/assets/img/maps/location.png">
    </div>

    <!-- MAPA -->
    <gmap-map 
      :center="center"
      :zoom="(zoom)"
      :options="mapStyle">
      <gmap-cluster :zoomOnClick="true" :styles="clusterStyles" :minimumClusterSize="2" :maxZoom="15">

        <gmap-marker v-for="(dealer, index) in dealers"
          :position="{ lat: parseFloat(dealer.geolocation.latitude), lng: parseFloat(dealer.geolocation.longitude) }"
          :clickable="true" 
          :draggable="false"
          @click="openMarker({lat: parseFloat(dealer.geolocation.latitude), lng: parseFloat(dealer.geolocation.longitude)}, index)"
          :key="index"
          :animation="2"
          :icon="(index === currentMarker) ? {url: dealer.urlIconActive} : {url: dealer.urlIcon}"
          >
          </gmap-marker>
        
        <gmap-marker
          v-if="latitude && longitude"
          :position="{ lat: parseFloat(latitude), lng: parseFloat(longitude) }"
          :clickable="true" 
          :draggable="false"
          >
          </gmap-marker>
      </gmap-cluster>
    </gmap-map>
  </div>
</template>

<script>
import axios from 'axios';
import $ from 'jquery'
import GmapCustomMarker from 'vue2-gmap-custom-marker';
import GmapCluster from 'vue2-google-maps/dist/components/cluster';

export default {
  name: "GoogleMap",
  data() {
    return {
      center: { lat: -31.742729, lng: -52.331732 },
      dealers: [],
      currentDealer: null,
      zoom: 17,
      listActive: false,
      currentMarker: null,
      currentPlace: null,
      longitude: null,
      latitude: null,
      cidade: 4913,
      cidades: {
        4913: {
          total: 0
        }
      },
      mapStyle:{
        zoomControl: true,
        mapTypeControl: false,
        scaleControl: true,
        streetViewControl: false,
        rotateControl: false,
        fullscreenControl: true,
        disableDefaultUI: true,
        scrollwheel: true,
        styles: [
          {
              "featureType": "all",
              "elementType": "geometry.fill",
              "stylers": [
                  {
                      "weight": "2.00"
                  }
              ]
          },
          {
              "featureType": "all",
              "elementType": "geometry.stroke",
              "stylers": [
                  {
                      "color": "#9c9c9c"
                  }
              ]
          },
          {
              "featureType": "all",
              "elementType": "labels.text",
              "stylers": [
                  {
                      "visibility": "on"
                  }
              ]
          },
          {
              "featureType": "administrative.land_parcel",
              "elementType": "geometry.fill",
              "stylers": [
                  {
                      "visibility": "on"
                  },
                  {
                      "color": "#372305"
                  },
                  {
                      "saturation": "-25"
                  }
              ]
          },
          {
              "featureType": "landscape",
              "elementType": "all",
              "stylers": [
                  {
                      "color": "#f2f2f2"
                  }
              ]
          },
          {
              "featureType": "landscape",
              "elementType": "geometry.fill",
              "stylers": [
                  {
                      "color": "#ffffff"
                  }
              ]
          },
          {
              "featureType": "landscape.man_made",
              "elementType": "geometry.fill",
              "stylers": [
                  {
                      "color": "#ffffff"
                  }
              ]
          },
          {
              "featureType": "poi",
              "elementType": "all",
              "stylers": [
                  {
                      "visibility": "off"
                  }
              ]
          },
          {
              "featureType": "road",
              "elementType": "all",
              "stylers": [
                  {
                      "saturation": -100
                  },
                  {
                      "lightness": 45
                  }
              ]
          },
          {
              "featureType": "road",
              "elementType": "geometry.fill",
              "stylers": [
                  {
                      "color": "#eeeeee"
                  }
              ]
          },
          {
              "featureType": "road",
              "elementType": "labels.text.fill",
              "stylers": [
                  {
                      "color": "#7b7b7b"
                  }
              ]
          },
          {
              "featureType": "road",
              "elementType": "labels.text.stroke",
              "stylers": [
                  {
                      "color": "#ffffff"
                  }
              ]
          },
          {
              "featureType": "road.highway",
              "elementType": "all",
              "stylers": [
                  {
                      "visibility": "simplified"
                  }
              ]
          },
          {
              "featureType": "road.arterial",
              "elementType": "labels.icon",
              "stylers": [
                  {
                      "visibility": "off"
                  }
              ]
          },
          {
              "featureType": "transit",
              "elementType": "all",
              "stylers": [
                  {
                      "visibility": "off"
                  }
              ]
          },
          {
              "featureType": "water",
              "elementType": "all",
              "stylers": [
                  {
                      "color": "#46bcec"
                  },
                  {
                      "visibility": "on"
                  }
              ]
          },
          {
              "featureType": "water",
              "elementType": "geometry.fill",
              "stylers": [
                  {
                      "color": "#c8d7d4"
                  }
              ]
          },
          {
              "featureType": "water",
              "elementType": "labels.text.fill",
              "stylers": [
                  {
                      "color": "#070707"
                  }
              ]
          },
          {
              "featureType": "water",
              "elementType": "labels.text.stroke",
              "stylers": [
                  {
                      "color": "#ffffff"
                  }
              ]
          }
      ]
      },
      clusterStyles : [
        {
          textColor: '#1c1c1c',
          url:'/cafe35/assets/img/maps/bg-cluster-1.png',
          height: 32,
          width: 32
        },
      {
          textColor: '#1c1c1c',
          url:'/cafe35/assets/img/maps/bg-cluster-2.png',
          height: 56,
          width: 56
        },
      {
          textColor: '#1c1c1c',
          url:'/cafe35/assets/img/maps/bg-cluster-3.png',
          height: 72,
          width: 72
        }
      ]
    };
  },

  mounted() {
    this.geolocate();
    axios.get('https://marbaweb.com.br/cafe35/backend/public/api/places', {})
    // axios.get('data/lojas.json', {})
      .then(response => {
          this.dealers = response.data.pontos;
          this.cidades = response.data.cidades;
      });
  },
  methods: {
    openMarker(position, index) {
      this.center = position;
      this.currentMarker = index;
      this.listActive = false;
      this.currentDealer = this.dealers[index];
      this.cidade = this.dealers[index].cidade;
      var elemento = this.currentMarker;
      
      setTimeout(function(){ 
        var listagem = document.getElementById('#listagem ul');
        var positionTop = document.getElementById(elemento);
        $('#listagem ul').animate({scrollTop:positionTop.offsetTop}, 500);
        this.zoom = 17;
      }, 300);
      

    },

    openList() {
      this.listActive = true;
      this.currentDealer = null;
    },

    closeList() {
      this.listActive = false;
    },

    geolocate: function() {
      navigator.geolocation.getCurrentPosition(position => {
        this.latitude = position.coords.latitude;
        this.longitude = position.coords.longitude;
        this.center = {
          lat: position.coords.latitude,
          lng: position.coords.longitude
        };
      });
    },
    
    onChange(event) {
        this.cidade = event.target.value;
        if(screen.width < 1024 ) {
          this.currentDealer = null;
          this.listActive = true;
        }
    }
  },
  components: {
    'GmapCluster': GmapCluster,
    'gmap-custom-marker': GmapCustomMarker
  }
};

$(window).on('load', function() {
  setTimeout(function(){ 
      $('#loading').fadeOut().remove();
        }, 3400);
});
</script>